/* Apply the shared FAQ footer layout without changing article copy. */
(() => {
  function placeContact() {
    document.querySelectorAll('#MainContent :is(.mw-fitment-faq, .mw-knowledge-faq, .publish-faq, .mw-guide-faq, .mw-noise-faq)').forEach(faq => {
      faq.classList.add('article-faq-unified');
      const section = faq.matches('section') ? faq : faq.closest('section');
      const article = faq.closest('article, .mw-wheel-measurement');
      if (!section || !article) return;
      section.classList.add('article-faq-section');
      const notice = article.querySelector('.mw-fitment-disclaimer, .mw-guide-disclaimer, .mw-knowledge-disclaimer, .mw-noise-disclaimer');
      const contact = [...section.querySelectorAll('p')].find(p => !p.closest('details') && p.querySelector('a[href="mailto:info@makstton.com"]'));
      if (!contact) return;
      contact.classList.add('mw-fitment-contact-note');
      if (notice) notice.before(contact);
    });
  }
  placeContact();
  document.addEventListener('shopify:section:load', placeContact);
})();
